import { ProjectPhase } from 'api/project';
import { ProjectTemplateTask } from '../types';
import { useGetAllTasks } from './use-get-all-tasks';
import { useProjectTemplateTask } from './use-task';

const findProjectPhase = (
  allTasks: { [key: string]: ProjectTemplateTask },
  task: ProjectTemplateTask,
): ProjectPhase | undefined => {
  if (!task) {
    return undefined;
  }
  if (task?.projectPhase) {
    return task?.projectPhase;
  }

  return findProjectPhase(allTasks, allTasks[task?.parentTask?.taskId]);
};

export const useGetProjectPhaseOfTask = (
  taskId: number,
): ProjectPhase | undefined => {
  const allTasks = useGetAllTasks();
  const task = useProjectTemplateTask(taskId);

  return task && findProjectPhase(allTasks, task);
};
